import Vue from 'vue';
import VeeValidate from 'vee-validate';

// Register it globally
Vue.use(VeeValidate);
